import { Validations } from '@/utils/Validations'
import { h } from 'vue'
import { VSelect } from 'vuetify/lib/components'
import './InputBase.scss'
import InputLabel from './InputLabel'

export const SelectBasico = VSelect.extend({
	name: 'SelectBasico',
	extends: VSelect,
	props: {
		outlined: { default: true },
		dense: { default: true },
		vModel: { default: '', type: String },
		label: { default: '', type: String },
		required: { default: false },
		hint: { default: '', type: String },
		instructions: { default: '', type: String },
		persistentPlaceholder: { default: true },
		rules: { type: Array<Function> },
		loading: { default: false }
	},
	computed: {
		computedProps(): Object {
			let props = {
				props: {
					...this.$props,
					loading: this.loading
				} as {
					[prop: string]: any
				}
			}

			if (this.$props.rules) {
				props = {
					props: {
						...props.props,
						rules: [...this.$props.rules, this.isRequired ? Validations.isRequired : () => true]
					}
				}
			}

			return props
		},

		isRequired(): boolean {
			if (this.required) return true
			if (this.rules) return this.rules.includes(Validations.isRequired)

			return false
		},
		fieldName(): string {
			if ('name' in this.$props) return this.$props['name']
			return ''
		}
	},
	methods: {
		renderLabel() {
			if (!this.label || this.label == undefined) return ''
			return <InputLabel label={this.label} required={this.isRequired} instructions={this.instructions} hint={this.hint} />
		},
		renderInput() {
			return h(VSelect, {
				class: 'my-2',
				on: this.listeners$,
				...this.computedProps,
				attrs: this.$attrs
			})
		}
	},
	render() {
		return h(
			'div',
			{
				class: 'd-flex flex-column app--input-base_wrapper'
			},
			[this.renderLabel(), this.renderInput()]
		)
	}
})

export default SelectBasico
